export default __webpack_public_path__ + "static/media/bronze.bd3e408d.png";